import React from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, ArrowRight } from 'lucide-react';

// Reusable advertising placeholder box. Routes to Contact page.
export default function AdBox({ size = '300 \u00d7 250', label = 'Your Ad Here', note = '', height = 250 }) {
  return (
    <Link to="/contact" className="block group">
      <div
        className="ad-shimmer relative rounded-xl border-2 border-dashed border-[#bcd6c8] flex flex-col items-center justify-center text-center px-4 transition-colors group-hover:border-[#2e9e6b]"
        style={{ height }}
      >
        <span className="absolute top-2 left-2 text-[9px] font-semibold uppercase tracking-wider text-[#9aa8a1]">Advertisement</span>
        <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-[#d8f3e3] text-[#157347] mb-2">
          <Megaphone className="w-5 h-5" />
        </span>
        <span className="font-display font-bold text-[#0f5132] text-lg">{label}</span>
        {note && <span className="text-xs text-[#5b6b63] mt-0.5">{note}</span>}
        <span className="text-[11px] text-[#9aa8a1] mt-1">{size}</span>
        <span className="inline-flex items-center gap-1 text-[12px] font-semibold text-[#157347] mt-2 group-hover:gap-1.5 transition-all">
          Advertise with us <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
}
